export default __webpack_public_path__ + "media/images/features/ana/title-34214bad4f1883b5a6f71ce63c722f58.png";